import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FaHome, FaCheck, FaFileAlt, FaClipboardCheck, FaCalendar, FaSignOutAlt, FaLayerGroup, FaExclamation, FaPauseCircle, FaClock, FaUserFriends,} from 'react-icons/fa';
import imagen2 from '../img/get_view2.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const handleInicioClick = () => navigate('/menulider');
  const handleGrupo1Click = () => navigate("/VerStaff");
  const handleEsperaDocumentacionClick = () => navigate('/ActividadesSinDocumentar');
  const handlePorAsignarClick = () => navigate('/AsignarStaff');
  const handleAsignadasClick = () => navigate('/SolicitudesAsignadas');
  const handleRevisarLiderClick = () => navigate('/RevisarActividadLider');
  const handleCompletadasLiderClick = () => navigate('/SolicitudesCompletadasLider');
  const handlePausaLiderClick = () => navigate('/PausaLider');
  const handleAnuladasClick = () => navigate('/SolicitudesAnuladasLider');
  const handleSeleccionaRolClick = () => navigate('/rol');

  const handleExitClick = () => {
    navigate('/'); // Redirige al usuario a la página de inicio de sesión o la ruta principal
    localStorage.clear(); // Elimina todos los elementos de localStorage
    window.location.reload(); // Refresca la página
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={imagen2} alt="GET View Logo" className="sidebar-logo" />
      </div>
      <div className="sidebar-section">
        <p>Aplicaciones</p>
        <div className="profile-link" onClick={handleInicioClick}>
          <FaHome /> Inicio
        </div>
        <div className="profile-link" onClick={handleGrupo1Click}>
          <FaLayerGroup /> Staff
        </div>
        <div className="profile-link multiline-text" onClick={handleEsperaDocumentacionClick}>
          <FaCalendar /> Solicitudes en espera de documentación
        </div>
        <div className="profile-link multiline-text" onClick={handlePorAsignarClick}>
          <FaFileAlt /> Solicitudes por asignar
        </div>
        <div className="profile-link" onClick={handleAsignadasClick}>
          <FaCheck /> Solicitudes asignadas
        </div>
        <div className="profile-link" onClick={handleRevisarLiderClick}>
          <FaClock /> Solicitudes por aprobar
        </div>
        <div className="profile-link" onClick={handlePausaLiderClick}>
          <FaPauseCircle /> Solicitudes pausadas
        </div>
        <div className="profile-link" onClick={handleAnuladasClick}>
          <FaExclamation /> Solicitudes anuladas
          </div>
        <div className="profile-link" onClick={handleCompletadasLiderClick}>
          <FaClipboardCheck /> Solicitudes finalizadas
        </div>
      </div>
      <div className="sidebar-section bottom-items">
        <p>Otros</p>
        <div className="profile-link" onClick={handleSeleccionaRolClick}>
          <FaUserFriends /> Seleccionar rol 
          </div>
        <div className="profile-link" onClick={handleExitClick}>
          <FaSignOutAlt /> Cerrar Sesión
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
